import { useState } from 'react';
import { useSelector } from 'react-redux';
import { createCoMaedcv } from '../../helpers/api_helper';

const useCreateCoMaedcv = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const tenantId = useSelector((state) => state.Context.tenantId);

    const createCoMaedcvRecord = async (datosCoMaedcv) => {
        setLoading(true);
        setError(null);
        try {
            console.log('Datos a guardar:', datosCoMaedcv);
            const response = await createCoMaedcv({
                coMaedcvData: datosCoMaedcv,
                tenantId
            });
            console.log('Response from API:', response);
            if (response.success) {
                const result = response.data;
                console.log('CO_MAEDCV creado con éxito:', result);
                return { success: true, data: result };
            } else {
                throw new Error(response.message || 'Error al guardar el registro CO_MAEDCV');
            }
        } catch (err) {
            const errorMessage = `Failed to create co_maedcv: ${err.message || 'Unknown error'}`;
            setError(errorMessage);
            console.error(errorMessage);
            return { success: false, error: errorMessage };
        } finally {
            setLoading(false);
        }
    };

    return { createCoMaedcv: createCoMaedcvRecord, loading, error };
};

export default useCreateCoMaedcv;